import { ScrollFade } from '../../ScrollFade';
import styles from './TgbStretchTemplate.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TgbStretchTemplate = props => {
  const {
    bgImageUrl,
    title,
    description,
    phone,
    address,
    note,
    url,
    label
  } = props;
  return /*#__PURE__*/_jsx("a", {
    className: styles['link'],
    href: url,
    rel: "noreferrer noopener nofollow",
    target: "_blank",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['container'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['image'],
        children: /*#__PURE__*/_jsx("img", {
          alt: title,
          src: bgImageUrl
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['aside'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['content'],
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles['title'],
            children: title
          }), /*#__PURE__*/_jsx("p", {
            className: styles['text'],
            children: description
          }), phone && /*#__PURE__*/_jsx("div", {
            className: styles['phone'],
            children: phone
          }), address && /*#__PURE__*/_jsx("div", {
            className: styles['address'],
            children: address
          })]
        }), note && /*#__PURE__*/_jsxs("div", {
          className: styles['note'],
          children: [note, /*#__PURE__*/_jsx(ScrollFade, {
            size: 18
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['advanced'],
        children: [/*#__PURE__*/_jsx("span", {
          children: label
        }), /*#__PURE__*/_jsx("span", {
          children: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"
        })]
      })]
    })
  });
};